/**
 * Staff email domains as typed: comma or space separated, lower case, without blanks or repeats. An
 * email address or `@domain` entry keeps only the part after the `@`, since the field asks for email
 * domains and people often type their own address. An entry with nothing after the `@` stays as
 * typed so `isDomain` refuses it.
 */
export const parseDomains = (text: string) =>
  text
    .split(/[,\s]+/)
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
    .map((entry) => entry.slice(entry.lastIndexOf("@") + 1) || entry)
    .filter((domain, index, all) => all.indexOf(domain) === index);

const DOMAIN =
  /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

/** True for a host name such as `lincolnusd.org`; the server also refuses public providers (FR-042). */
export const isDomain = (value: string) => DOMAIN.test(value);
